import axios from "axios";

class ApiClient {
  constructor(url, lang, key, accessToken) {
    const headers = {
      "Content-Type": "application/json",
      "Ocp-Apim-Subscription-Key": key,
      "cache-control": "no-cache"
    };

    if (accessToken) {
      headers.Authorization = `Bearer ${accessToken}`;
    }

    return axios.create({
      baseURL: `${url}/${lang}/`,
      headers
    });
  }
}

export default ApiClient;
